module.exports = __webpack_public_path__ + "img/terms-dots.280d898.svg";